import {useNavigate, useParams} from "react-router-dom";
import {Alert, Card, CardContent, CircularProgress, Typography} from "@mui/material";
import SnackError from "../../components/SnackError";
import React from "react";
import {PersonApiPut, useGetPersonByIdQuery, usePutPersonByIdMutation} from "./people_api";
import PersonForm from "./PersonForm";


export const PersonEdit = () => {

    const {id} = useParams<"id">()
    const {data, isFetching} = useGetPersonByIdQuery({
        id: parseInt(id|| "")
    });

    const [put, {
        isLoading: isUpdating,
        error,
        isError,
    }] = usePutPersonByIdMutation();
    const navigate = useNavigate();
    const params = useParams<"id">();

    const handleSubmit = async function (values: PersonApiPut) {
        const res = await put({id: parseInt(params.id || ""), body: values})
        if ("data" in res) {
            navigate("..")
        }
    };
    if (!data || isFetching)
        return <CircularProgress/>;

    if (!data) return <Alert severity={"error"}>Not found</Alert>

    return <Card sx={{mt: "2em"}}>
        <CardContent>
            <Typography variant={"h1"}>{data && data.firstName +" " + data.lastName }</Typography>
        </CardContent>
        {isError && <SnackError error={error}/>}
        <PersonForm
            isUpdating={isUpdating}
            onSubmit={handleSubmit}
            onCancel={() => navigate("..", {replace: true})}
            object={data}
        />
    </Card>;
}
